export default __webpack_public_path__ + "static/media/searching_re_stk8.a599b136.svg";